import { Obj } from '../framework/utils';
import request from '@/utils/request';

export default {
  ...Obj.generateCURD('/search/searchconfig', request)
};
